import React, { FC } from 'react'
import classNames from 'classnames'

import './QuizOption.less'
import { IQuizOption } from '../types'
import IconTick from 'front-end/src/components/common/icon/IconTick'
import IconX from 'front-end/src/components/common/icon/IconX'

export const percentageOfTotalFormatter = (
  part: number,
  total: number,
  separator = ''
) => {
  if (total === 0) {
    return ''
  }
  const onePercent = total / 100
  const result = part / onePercent

  if (String(result).includes('.')) {
    return `${result.toFixed(1)}${separator}%`
  } else {
    return `${result}${separator}%`
  }
}

export const QuizOption: FC<{
  option: IQuizOption
  responsesBreakdown?: {
    correct: number
    incorrect: number
  }
  isOpenQuiz: boolean
  totalResponses: number
  isCorrect: boolean
  viewAsStudent: boolean
}> = (props) => {
  const {
    option,
    responsesBreakdown,
    isOpenQuiz,
    totalResponses,
    isCorrect,
    viewAsStudent = false
  } = props
  const { clickRate } = option

  const isSelected = !!(option.response_value || responsesBreakdown)
  const isAnswerCorrect = option?.is_correct

  return (
    <div
      key={option.id}
      className={classNames('QuizOption', {
        'QuizOption-viewAsStudent': viewAsStudent,
        'QuizOption-viewAsAdmin': !viewAsStudent,
        'QuizOption-selected': isSelected,
        'QuizOption-correct': Boolean(
          !isOpenQuiz &&
            (option.response_is_correct || isCorrect || responsesBreakdown)
        ),
        'QuizOption-incorrect': Boolean(
          (!isCorrect && option.response_value) ||
            (!option.response_is_correct && responsesBreakdown && !isOpenQuiz)
        ),
        'QuizOption-no-correct': Boolean(
          isOpenQuiz ||
            (!isCorrect && option.response_value) ||
            (!option.response_is_correct && responsesBreakdown)
        )
      })}
    >
      <a className="QuizOption__toggle">
        <span className="icon" />
      </a>
      <div dangerouslySetInnerHTML={{ __html: option.content }} />
      {viewAsStudent && !isOpenQuiz && !!totalResponses && (
        <div className="QuizOption__mark">
          {isAnswerCorrect && isSelected && <IconTick />}
          {!isAnswerCorrect && !isSelected && <IconTick />}
          {!isAnswerCorrect && isSelected && <IconX />}
        </div>
      )}
      {!!clickRate && !!totalResponses && (
        <div
          className={classNames(
            {
              'QuizOption__percentage-bad':
                !option.response_is_correct && !isOpenQuiz,
              'QuizOption__percentage-good':
                option.response_is_correct || isOpenQuiz
            },
            'QuizOption__percentage'
          )}
        >
          <div className="QuizOption__progressBar">
            <span
              className="QuizOption__progressBar__fill"
              style={{
                width: percentageOfTotalFormatter(
                  clickRate.clicks,
                  clickRate.totalResponses
                )
              }}
            />
            <span className="QuizOption__progressBar__value">
              {percentageOfTotalFormatter(
                clickRate.clicks,
                clickRate.totalResponses,
                ''
              )}
            </span>
          </div>
        </div>
      )}
    </div>
  )
}
